export const SURVEY_STATUS_ENUM = {
    PAUSED: 'paused',
    STOPPED: 'stopped',
    // COMPLETED: 'completed',
}